<template>
  <div
    class="preview-shape"
    :data-id="config.id"
    :style="wrapStyle"
    @click="handleClick"
  >
    <component
      :is="config.component"
      class="component"
      :style="curStyle"
      :styleDatas="config.style"
      :prop-value="config.propValue"
      :element="config"
      :allBtnPressMap="allBtnPressMap"
      :isPreview="true"
      :currentComps="currentComps"
      :childPageComps="childPageComps"
      @changeCurComp="changeCurComp"
      @changePage="changePage"
      @changeBtnPress="changeBtnPress"
    />
  </div>
</template>

<script>
import { getStyle } from "@/utils/style";
import runAnimation from "@/utils/runAnimation";
import { mixins } from "@/utils/events";

export default {
  mixins: [mixins],
  props: {
    config: {
      type: Object,
      require: true,
      default: () => {},
    },
    currentComps: {
      type: String,
      require: false
    },
    childPageComps: {
      type: Array,
      require: false
    },
    allBtnPressMap: {
      type: Object,
      require: true
    }
  },
  computed: {
    wrapStyle() {
      const s = this.config.style || {};
      const result = {
        left: (s.left || 0) + "px",
        top: (s.top || 0) + "px",
        width: (s.width || 0) + "px",
        height: (s.height || 0) + "px",
      };
      if (s.rotate) {
        result.transform = "rotate(" + s.rotate + "deg)";
      }
      if (s.zIndex != null && s.zIndex !== "") {
        result.zIndex = s.zIndex;
      }
      return result;
    },
    curStyle() {
      let filters = ["top", "left", "width", "height", "rotate"];
      if (this.config.component === "v-button") {
        filters = filters.concat(["backgroundImage", "backgroundColor"]);
      }
      return getStyle(this.config.style, filters);
    }
  },
  mounted() {
    runAnimation(this.$el, this.config.animations);
  },
  methods: {
    getStyle,

    handleClick() {
      const name =
        this.config.component === "v-button"
          ? this.config.propValue
          : this.config.label || this.config.component;
      const hasLinks =
        this.config.componentLinks &&
        this.config.componentLinks.links &&
        this.config.componentLinks.links.length > 0;
      if (hasLinks) {
        console.log(
          `[预览·点击组件] 组件「${name}」（id：${this.config.id}，类型：${this.config.component}）已配置「组件联动」，具体样式指令由联动目标上的监听事件执行（若未生效请检查触发源与监听事件是否匹配）。`
        );
      } else if (this.config.component !== "v-button") {
        console.log(
          `[预览·点击组件] 组件「${name}」（id：${this.config.id}，类型：${this.config.component}）。当前类型在预览中无额外脚本联动，仅作界面点击反馈。`
        );
      }
    },
    changeCurComp(datas) {
      this.$emit('changeCurComp', datas);
    },
    changePage(key) {
      this.$emit('changePage', key);
    },
    changeBtnPress(arr) {
      this.$emit('changeBtnPress', arr);
    }
  },
};
</script>

<style lang="scss" scoped>
.preview-shape {
  position: absolute;
}
.component {
  width: 100%;
  height: 100%;
}
</style>
